export default "__VITE_ASSET__5f54bf4d__"